import { FlexComp, H5Tag, ImageComponent, ParaTag, SpanTag } from "@tm/static";
import { useBreakpointV2 } from "@tm/ui-widgets";
import FormattedText, { TextNodeType } from "../FormattedText/FormattedText";
import { FeatList, SafenSecureTravCrdStyle } from "./SafenSecureTrav.style";

interface SafenSecureTravCrdProps {
  title?: TextNodeType;
  featList?: TextNodeType[];
  poweredBy?: string[];
  additionalInfo?: TextNodeType;
  cardImg?: string;
  cardQuantity?: number;
}

const SafenSecureTravCrd = ({
  title,
  featList,
  cardImg,
  poweredBy,
  additionalInfo,
  cardQuantity,
}: SafenSecureTravCrdProps) => {
  const device = useBreakpointV2();
  return (
    <SafenSecureTravCrdStyle>
      {device == "lg" ? (
        <H5Tag>{title && <FormattedText value={title} />}</H5Tag>
      ) : (
        <ParaTag
          fontWeight="black"
          fontSize="large"
          margin={device == "sm" ? "" : "0 0 12px"}
        >
          {title && <FormattedText value={title} />}
        </ParaTag>
      )}
      <FeatList cardQuantity={cardQuantity}>
        {featList &&
          featList?.map((item: TextNodeType, index: number) => {
            return (
              <li key={index}>
                <FormattedText value={item} />
              </li>
            );
          })}
      </FeatList>
      {poweredBy && (
        <FlexComp margin="auto 0 0" gap="20px" alignItems="Center">
          <SpanTag fontSize="xs">Powered By</SpanTag>
          {poweredBy &&
            poweredBy.map((item, index) => {
              return (
                <ImageComponent
                  key={index}
                  src={item}
                  height={"32px"}
                  width={"auto"}
                />
              );
            })}
        </FlexComp>
      )}
      {additionalInfo && <FormattedText value={additionalInfo} />}
      {cardImg && (
        <ImageComponent
          width={
            device == "lg" ? (cardQuantity === 1 ? "auto" : "92px") : "54px"
          }
          height={
            device == "lg" ? (cardQuantity === 1 ? "126px" : "102px") : "60px"
          }
          src={cardImg}
        />
      )}
    </SafenSecureTravCrdStyle>
  );
};

export default SafenSecureTravCrd;
